var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.5rem",
    height: "0.5rem",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dokumentace-190326",
    transform: "translate(-1409.000000, -1224.000000)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(1409.000000, 1224.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.357689,17 L0.627017842,17 C0.275276126,17 0,17.2317073 0,17.5 C0,17.7682927 0.290569244,18 0.627017842,18 L17.3729822,18 C17.7247239,18 18,17.7682927 18,17.5 C18,17.2317073 17.7094308,17 17.357689,17 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0147991543,11.25 L0,14.335443 C0,14.5094937 0.0591966173,14.6835443 0.177589852,14.8101266 C0.295983087,14.9367089 0.44397463,15 0.606765328,15 L3.47780127,14.9841772 C3.64059197,14.9841772 3.78858351,14.9208861 3.90697674,14.7943038 L13.8224101,4.19303797 C14.0591966,3.93987342 14.0591966,3.52848101 13.8224101,3.25949367 L10.9809725,0.189873418 C10.744186,-0.0632911392 10.359408,-0.0632911392 10.1078224,0.189873418 L8.12473573,2.32594937 L0.192389006,10.7911392 C0.088794926,10.9177215 0.0147991543,11.0759494 0.0147991543,11.25 Z M10.551797,1.58227848 L12.5496829,3.71835443 L11.4249471,4.92088608 L9.42706131,2.78481013 L10.551797,1.58227848 Z M1.24312896,11.5348101 L8.55391121,3.71835443 L10.551797,5.85443038 L3.2410148,13.6550633 L1.22832981,13.6708861 L1.24312896,11.5348101 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/EditPencilIcon.25035baf63d2a9af6a6346d3b189408d.svg";
export { ForwardRef as ReactComponent };